<template>
  <el-container>
    <!-- <el-header class="table-header">
      <el-button align="center" @click="search('refresh')" size="small">{{
        $t("common.Search")
      }}</el-button>
      <el-button @click="reset" align="center" size="small">刷新</el-button>
    </el-header> -->
    <el-main class="table-main no-overflow">
      <!-- <el-form :model="form" label-width="80px" size="mini" class="table-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="标题">
              <el-input
                v-model="form.stockInNo"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发布人">
              <el-input
                v-model="form.stockInNo"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发布时间">
              <el-input
                v-model="form.stockInNo"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form> -->
      <el-tabs v-model="activeName" @tab-click="handleClick" id="msg">
        <el-tab-pane label="未读" name="first">
          <ul>
            <li>
              <div>
                <span class="name">王鹏</span>
                <span>就是贷款圣诞节反倒是圣诞节氨基酸看得开就爱上</span>
                <el-button type="text">查看详情</el-button>
              </div>
              <span class="time">2022-02-05 12:05:23</span>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="已读" name="second">
          <ul v-for="(item, index) in dataList" :key="index">
            <li></li>
          </ul>
        </el-tab-pane>
      </el-tabs>
      <el-footer class="table-footer" style="float: right;">
        <table-page
          ref="stockInListPage"
          :url="stockInListUrl"
          :form="form"
          @page-change="convert"
        ></table-page>
      </el-footer>
    </el-main>
  </el-container>
</template>

<script>
import TablePage from "@/components/TablePage";
import moment from "moment";

export default {
  name: "msgList",
  data() {
    return {
      form: {},
      stockInListUrl: this.global.BASE_INFO + "/message/find",
      dataList: [],
      activeName: 'first'
    };
  },
  computed: {
  },
  components: {
    TablePage,
  },
  activated() {
    this.search;
  },
  methods: {
    handleClick(){},
    reset() {
      this.form = {};
      this.$nextTick(() => {
        this.search();
      });
    },
    search(param) {
      this.form.beginDay = "";
      this.form.endDay = "";
      if (this.form.date) {
        this.form.beginDay = this.form.date[0];
        this.form.endDay = this.form.date[1];
      }
      this.$refs["stockInListPage"].getTableData(param);
    },
    convert(tableData) {
      this.dataList = tableData.data;
    },
    changeTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
#msg ul li {
  list-style: none;
  padding: 10px 0;
}
#msg .time {
  color: #ccc;
  font-size: 12px;
}
#msg .name {
  color: #409EFF;
}
#msg .el-button--text {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/main/components/msgList.vue